import { Header, HeroImage, HeroSection, SubHeader, HeroOverlay, Button, ButtonsWrapper } from "./styled";
import Hero1080 from "./baner-1080p.webp";
import Hero1440 from "./baner-1440p.webp";
import { useTranslation } from "react-i18next";

const Hero = () => {
    const { t } = useTranslation();

    const getScrollOffset = () => (window.innerWidth <= 768 ? -50 : -90);

    return (
        <HeroSection id="home">
            <picture>
                <source srcSet={Hero1440} media="(min-width: 1921px)" />
                <HeroImage src={Hero1080} alt="Czorsztynianka hero image and logo" />
            </picture>

            <HeroOverlay>
                <Header>{t("hero.title")}</Header>
                <SubHeader>{t("hero.subtitle")}</SubHeader>

                <ButtonsWrapper>
                    <Button to="services" smooth duration={600} offset={getScrollOffset()}>
                        {t("hero.cta.offer")}
                    </Button>

                    <Button to="address" smooth duration={600} offset={getScrollOffset()}>
                        {t("hero.cta.contact")}
                    </Button>
                </ButtonsWrapper>
            </HeroOverlay>
        </HeroSection>
    );
};

export default Hero;